import React, { Component } from 'react';
import cn from 'classnames';
import { filterUsablePlans, isUnlimited } from 'subscriptions/plans/utils';
import * as routes from 'app/routes';
import DataMeter from './DataMeter';
import Box from 'common/Box';
import Link from 'common/Link';
import Button from 'forms/Button';
import StaticWarning from 'notifications/StaticWarning';
import StaticInfo from 'notifications/StaticInfo';
import styles from './AddDataPicker.module.css';

export const totalDue = (currentPrice, newPrice) => {
  const parsedCurrent = parseFloat(currentPrice);
  const parsedNew = parseFloat(newPrice);
  const diff = parsedNew - parsedCurrent;
  return diff.toFixed(0);
}

class AddDataPicker extends Component {

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    if (this.props.subId !== oldProps.subId) {
      this.fetchData();
    }
    if (this.props.currentPlan !== oldProps.currentPlan) {
      this.selectPlan(this.props.currentPlan);
    }
    if (this.props.user !== oldProps.user) {
      this.fetchData();
    }
  }

  fetchData() {
    const { findUpcomingPlan, fetchAllPlans, fetchFilteredPurchases, findCurrentUsage, subId, user } = this.props;
    if (!subId || !user) { return; }
    fetchAllPlans(subId);
    findUpcomingPlan && findUpcomingPlan(subId);
    findCurrentUsage(subId);
    fetchFilteredPurchases(user.id, { status: 'overdue' });
  }

  state = {}

  selectPlan = (plan) => {
    this.setState({
      selectedPlan: plan
    });
  }

  render() {
    const { subscription, upcomingPlan, currentPlan, allPlans, usage, createUpgradePurchase, purchaseRoute, overduePurchases } = this.props;
    const { selectedPlan } = this.state;

    if (
      (subscription && subscription.sprint_status !== 'active' && subscription.bypassed_status !== 'active' && subscription.quick_status !== 'active') ||
      (currentPlan && currentPlan.plan_type === 'Parking')
    ) {
      return (
        <Box>
          This line is not eligible to add data. Contact a Wing agent in the chat below for more information.
        </Box>
      )
    }

    if (overduePurchases && overduePurchases.length > 0) {
      const firstOverdue = overduePurchases[0];
      return (
        <StaticWarning>
          Looks like you have an overdue purchase. Please
          {' '}
          <Link to={routes.unpaidPurchase(firstOverdue.id)}>
            complete checkout
          </Link>
          {' '}
          before you add data.
        </StaticWarning>
      )
    }

    if (currentPlan && isUnlimited(currentPlan)) {
      return (
        <StaticInfo>
          You already have an unlimited plan—no need to upgrade!
        </StaticInfo>
      )
    }

    if (!subscription || !usage || !allPlans || !selectedPlan) { return null; }

    const usablePlans = filterUsablePlans(allPlans, currentPlan, upcomingPlan).slice(0, 8);
    let planNameSize = '';
    if (usablePlans.length > 8) {
      planNameSize = 12;
    } else if (usablePlans.length > 7) {
      planNameSize = 14;
    } else if (usablePlans.length > 5)  {
      planNameSize = 16;
    }

    return (
      <div className={styles.AddDataPicker}>
        <Box>
          <DataMeter oldAvail={currentPlan.data_available} newAvail={selectedPlan.data_available} mbUsed={usage.mb_used} isUnlimited={isUnlimited(selectedPlan)} />
          <p className={styles.upgradeText}>Upgrade to a new plan and only pay the difference between plans</p>
          <div className={styles.picker}>
            <div className={styles.plans}>
              {usablePlans.map(plan =>{
                const isDisabled = usage.mb_used > plan.data_available;
                  return (
                    <div
                      className={cn(
                        styles.plan,
                        plan.id === selectedPlan.id && styles.selected,
                        isDisabled && styles.disabled,
                      )}
                      key={plan.id} onClick={() => !isDisabled && this.selectPlan(plan)}
                    >
                      <h4 style={{ fontSize: planNameSize + 'px' }}>{plan.name}</h4>
                      {plan.id === currentPlan.id &&
                        <p>
                          (current)
                        </p>
                      }
                    </div>
                  )
                }
              )}
            </div>
            <div className={styles.amountDueWrapper}>
              <div className={styles.dueLabel}>
                Amount Due
              </div>
              <div className={styles.due}>
                <span className={styles.dueDollar}>$</span>
                <span className={styles.amountDue}>
                  {totalDue(currentPlan.price, selectedPlan.price)}
                </span>
              </div>
            </div>
          </div>
          <Button onClick={() => {
            purchaseRoute(subscription.id, selectedPlan.id);
          }} disabled={selectedPlan.id === currentPlan.id}>
            Continue with this plan
          </Button>
        </Box>
      </div>
    )
  }
}

export default AddDataPicker;
